import { PrintOptionsRecord } from "../../types/immutableRecords/printing/PrintOptionsRecord";
import { actionTypes } from "./actions";

const reducer = (state = PrintOptionsRecord(), action) => {
  switch (action.type) {
    case actionTypes.SET_PRINT_PAPER_SIZE:
      return state.set("paperSize", action.size);
    case actionTypes.SET_PRINT_ORIENTATION:
      return state.set("orientation", action.orientation);
    case actionTypes.SET_PRINT_SCALE:
      return state.set("scale", action.scale);
    default:
      return state;
  }
};

export default reducer;
